import type { RouteRecordNormalized } from 'vue-router';
import type { ObjectComponent } from './types';

const modules = import.meta.glob('./modules/*.ts', { eager: true }) as Record<
  string,
  { default: ObjectComponent }
>;

const formatModules = (
  _modules: Record<string, { default: Object }>,
  result: RouteRecordNormalized[]
) => {
  Object.keys(_modules).forEach(key => {
    const defaultModule = _modules[key].default;
    if (!defaultModule) {
      return;
    }
    const moduleList = Array.isArray(defaultModule)
      ? [...defaultModule]
      : [defaultModule];
    result.push(...moduleList);
  });
  return result;
};

export const appRoutes: RouteRecordNormalized[] = formatModules(modules, []);
